// extracted by mini-css-extract-plugin
export var container = "ProductLeadDescription-module--container--f395e";
export var detail = "ProductLeadDescription-module--detail--64907";
export var term = "ProductLeadDescription-module--term--9e30c";